import { get, post } from '@/api/fetch';
import { captureError } from '@smg-real-estate/browser-rum';

export const authenticateForImages = async (): Promise<ChatRelayAuthResponse | undefined> =>
  await connect('describe_images');

export const authenticate = async (): Promise<ChatRelayAuthResponse | undefined> =>
  await connect('listing_description');

const connect = async (useCase: string): Promise<ChatRelayAuthResponse | undefined> => {
  const url = `${import.meta.env.VUE_APP_CHAT_RELAY_API_URL}/connect?use_case=${useCase}`;

  try {
    const response = await get(url);
    return response.json();
  } catch (error) {
    captureError(new ChatRelayApiError(url, error.message));

    return undefined;
  }
};

export const generateImageDescription = async (
  connectionId: string,
  imageUrls: string[],
): Promise<ImageDescriptionResponse> => {
  const url = `${import.meta.env.VUE_APP_CHAT_RELAY_API_URL}/describe-images/${connectionId}?use_case=listing_description`;

  try {
    const response = await post(url, JSON.stringify({ imageUrls }));
    return response.json();
  } catch (error) {
    captureError(new ChatRelayApiError(url, error.message));
  }

  return { imageDescriptions: {}, hasError: true };
};

export interface ChatRelayAuthResponse {
  ConnectionId: string;
  TTL: number;
  Email: string;
  UseCase: string;
}

export interface ImageDescriptionResponse {
  imageDescriptions: {
    [key: string]: string;
  };
  hasError: boolean;
}

export interface GeneratedImageDescription {
  imageUrl: string;
  features?: GeneratedImageFeatures;
}

export interface GeneratedImageFeatures {
  description?: string;
  type?: string;
  visible_features?: string[];
}

export class ChatRelayApiError extends Error {
  endpoint: string;

  constructor(endpoint: string, message: string) {
    super(`Unexpected error happened: ${message}`);

    this.name = 'ChatRelayApiError';
    this.endpoint = endpoint;
  }
}
